import React from 'react';
import { Variant } from './Nav.types';

type ContextType = {
  variant: Variant;
};

const Context = React.createContext<ContextType>({ variant: 'website' });

export default Context;

